export default "__VITE_ASSET__mHcCSmTe__"